import { LOCALE } from "./NumberUtils"
const formatter = new Intl.NumberFormat(LOCALE, {style: "currency", currency: "EUR"});

export function toEuroCurrency(value) {
  if (value === undefined || value === null) {
    return "";
  }
  return formatter.format(value);
}
